module.exports = __webpack_public_path__ + "img/img_4.7d22688d.jpg";